//////////////////////////////////////////////////

import ObjectFactory from "./ObjectFactory";
import BaseObject from "./BaseObject";
import BaseModel from "./BaseModel";
import BaseModelReferenceTreeviewModel from "../modelTreeViews/BaseModelReferenceTreeviewModel";
import { itx } from "../translationItx/itx";
import type GroupAddress from "./GroupAdress";

ObjectFactory.registerClass("BaseModelReference", (data?: any, parent?: BaseModel) => {
  // no itx
  return new BaseModelReference(data, parent);
});

export interface usefromRefencedTreeviewObjectInterface {
  titlePostfix: boolean;
  fullTitle: boolean;
  icon: boolean;
  showChildern?: boolean;
  menuButtons?: boolean;
}

export default class BaseModelReference extends BaseModel {
  public get className(): string {
    return "BaseModelReference"; // no itx
  }

  referencedObject?: BaseModel;

  override get _selected(): boolean {
    return this.referencedObject?._selected ?? false;
  }

  override set _selected(newValue: boolean) {
    if (this.referencedObject) {
      this.referencedObject._selected = newValue;
    }
  }

  usefromRefencedTreeviewObject: usefromRefencedTreeviewObjectInterface = {
    titlePostfix: false,
    fullTitle: true,
    icon: false,
    showChildern: false,
    menuButtons: false,
  };

  constructor(
    data: {
      referencedObject?: BaseModel;
      overwriteFulltag?: string;
    },
    parent?: BaseObject,
  ) {
    super({ storeInObjectRegistry: false,  isTemporary: true, isPersistent: false }, parent);
    this.referencedObject = data.referencedObject;
    this.treeViewModel = new BaseModelReferenceTreeviewModel(this);
    this.overwriteFulltag = data.overwriteFulltag;
  }

  overwriteFullTitle: string | JSX.Element | undefined;
  overwriteFulltag: string | undefined;
  overwriteIcon: any | undefined;
  overwritePostfix: string | JSX.Element | undefined;
  overwritePrefix: string | JSX.Element | undefined;

  additionalInlineButtons?: Array<any>;

  get isLoadedFromPersistence(): boolean | undefined {
    return this.referencedObject?.isLoadedFromPersistence;
  }

  set isLoadedFromPersistence(newValue: boolean | undefined) {}

  onDisconnect?: () => boolean;

  // getIconUrl(): string | undefined {
  //   if (this.overwriteIcon) {
  //     return this.overwriteIcon;
  //   }

  //   if (this.usefromRefencedTreeviewObject.icon) {
  //     return this.referencedObject?.treeViewModel.getIconUrl();
  //   }
  //   return undefined;
  // }

  get icon(): any | undefined {
    if (this.overwriteIcon) {
      return this.overwriteIcon;
    }

    if (this.usefromRefencedTreeviewObject.icon) {
      return this.referencedObject?.treeViewModel.icon;
    }
    return undefined;
  }

  get fullTag(): string {
    if (this.overwriteFulltag != undefined) {
      return this.overwriteFulltag;
    }
    return this.referencedObject?.fullTag || "????";
  }

  getTag(): string {
    if (this.overwriteFulltag != undefined) {
      return this.overwriteFulltag;
    }
    if (this.parent?.parent) {
      return this.referencedObject?.getRelativeTag(this.parent?.parent as BaseModel) || "????";
    } else {
      return this.referencedObject?.fullTag || "????";
    }
  }
  setTag(newValue: string) {}

  getName(): string {
    return this.referencedObject?.displayName || "";
  }
  setName(newValue: string) {}

  getDeleteConfirmText(): string | undefined {
    if (this.parent?.className == "GroupAddress" && this.referencedObject?.className == "Signal") {
      if ((this.parent as GroupAddress)?.isManualGroupAddress) {
        return itx(
          "deleteConfirmText.groupAddressSignalReference",
          "Möchten Sie die Verbindung zwischen Gruppenadresse und Signal wirklich löschen?",
        );
      }
    }
    return undefined;
  }
  canBeDeletedInteractive(): boolean {
    if (this.parent?.className == "GroupAddress" && this.referencedObject?.className == "Signal") {
      return false; // has to be false to show confirmText
    }
    return super.canBeDeletedInteractive();
  }
  delete(): Array<BaseObject> {
    const parent = this.parent;
    switch (parent?.className) {
      case "GroupAddress":
        const groupAddress = parent as any;
        if (this.referencedObject?.className == "Signal" && groupAddress.isManualGroupAddress) {
          const signal = this.referencedObject as any;
          const ga = groupAddress;

          signal.groupAddresses.remove(ga);
          ga.removeSignalBackpointer(signal);

          signal.raiseOnChangeUI("childCollection");
          signal.raiseOnChange("groupAddresses");
          ga.raiseOnChange("signalBackpointer");
          ga.raiseOnChangeUI("childCollection");
        }
    }

    return [];
  }
}
